export const VIEW_MODES = {
  GRAPHICAL: 'graphical',
  LIST: 'list',
  SAVI: 'savi',
} as const;

export type ViewMode = (typeof VIEW_MODES)[keyof typeof VIEW_MODES];

export interface ViewModeButton {
  mode: ViewMode;
  icon: 'Analyze' | 'MenuHamburger';
  label: string;
  position: 'start' | 'end';
}

export interface TabsProps {
  onTabChange?: (tabId: string) => void;
  onViewModeChange?: (mode: ViewMode) => void;
  viewMode?: ViewMode;
  title?: string;
  sortBy?: string;
  onSortChange?: (sortOption: string) => void;
  sortOptions?: { label: string; value: string }[];
  onSettingsClick?: () => void;
  isFindingsOpen?: boolean;
  onFindingsToggle?: () => void;
}

export const VIEW_MODE_BUTTONS: ViewModeButton[] = [
  {
    mode: VIEW_MODES.GRAPHICAL,
    icon: 'Analyze',
    label: 'Graphical view',
    position: 'start',
  },
  {
    mode: VIEW_MODES.LIST,
    icon: 'MenuHamburger',
    label: 'List view',
    position: 'end',
  },
];

export const DEFAULT_SORT_OPTIONS = [
  { label: 'By Annual Cost', value: 'annual-cost' },
  { label: 'By License Count', value: 'license-count' },
  { label: 'By Utilization', value: 'utilization' },
  { label: 'By Risk Level', value: 'risk-level' },
];

export const TAB_IDS = {
  OVERVIEW: 'overview',
  SIMULATION: 'simulation',
  FORECASTING: 'forecasting',
  REPORTING: 'reporting',
} as const;

export type TabId = (typeof TAB_IDS)[keyof typeof TAB_IDS];

export interface Tab {
  id: TabId;
  label: string;
}
